import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="relative bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-3/5">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-semibold uppercase tracking-widest text-foreground-700">FAQ em Destaque</span>
            </div>

            <div className="mb-10">
              <p className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
                &ldquo;O <strong>Hoobuy Spreadsheet</strong><br />
                é uma coleção organizada<br />
                de mais de 20.000 produtos<br />
                com links atualizados.&rdquo;
              </p>
              <div className="flex items-center gap-2 mt-6">
                <span className="text-sm font-semibold text-foreground-800">Equipe Hoobuy</span>
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <span className="text-xs text-foreground-500">Verificado 2026</span>
              </div>
            </div>

            <div className="space-y-3">
              {faqItems.map((item, index) => (
                <div
                  key={index}
                  className="border border-background-200/70 rounded-xl overflow-hidden transition-all duration-200"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                  >
                    <span className="text-sm font-semibold text-foreground-900 pr-4">{item.question}</span>
                    {openIndex === index ? (
                      <i className="ri-arrow-up-s-line text-foreground-500 text-lg flex-shrink-0"></i>
                    ) : (
                      <i className="ri-arrow-down-s-line text-foreground-500 text-lg flex-shrink-0"></i>
                    )}
                  </button>
                  {openIndex === index && (
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-2/5">
            <div className="rounded-2xl overflow-hidden h-full min-h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20fashion%20editorial%20portrait%20style%20image%20with%20warm%20cream%20background%2C%20artistic%20arrangement%20of%20sneakers%20and%20accessories%20in%20soft%20diffused%20lighting%2C%20elegant%20composition%20with%20neutral%20tones%2C%20lifestyle%20product%20photography%20aesthetic%2C%20white%20studio%20setting%20with%20gentle%20shadows&width=600&height=900&seq=hoobuy-faq-portrait-06&orientation=portrait"
                alt="Hoobuy Spreadsheet FAQ"
                title="Hoobuy Spreadsheet - Perguntas Frequentes"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
};

export default FAQSection;